/**
 * Lanaguage code detected via NNetLanguageIdentifier
 * https://github.com/google/cld3/blob/87dae6b75537d5f64a6dcf97a9e1d411620f5cd1/src/task_context_params.cc#L43
 */
export var LanguageCode;
(function (LanguageCode) {
    LanguageCode["EO"] = "eo";
    LanguageCode["CO"] = "co";
    LanguageCode["EU"] = "eu";
    LanguageCode["TA"] = "ta";
    LanguageCode["DE"] = "de";
    LanguageCode["MT"] = "mt";
    LanguageCode["PS"] = "ps";
    LanguageCode["TE"] = "te";
    LanguageCode["SU"] = "su";
    LanguageCode["UZ"] = "uz";
    LanguageCode["ZH_LATN"] = "zh-Latn";
    LanguageCode["NE"] = "ne";
    LanguageCode["NL"] = "nl";
    LanguageCode["SW"] = "sw";
    LanguageCode["SQ"] = "sq";
    LanguageCode["HML"] = "hmn";
    LanguageCode["JA"] = "ja";
    LanguageCode["NO"] = "no";
    LanguageCode["MN"] = "mn";
    LanguageCode["SO"] = "so";
    LanguageCode["KO"] = "ko";
    LanguageCode["KK"] = "kk";
    LanguageCode["SL"] = "sl";
    LanguageCode["IG"] = "ig";
    LanguageCode["MR"] = "mr";
    LanguageCode["TH"] = "th";
    LanguageCode["ZU"] = "zu";
    LanguageCode["ML"] = "ml";
    LanguageCode["HR"] = "hr";
    LanguageCode["BS"] = "bs";
    LanguageCode["LO"] = "lo";
    LanguageCode["SD"] = "sd";
    LanguageCode["CY"] = "cy";
    LanguageCode["HY"] = "hy";
    LanguageCode["UK"] = "uk";
    LanguageCode["PT"] = "pt";
    LanguageCode["LV"] = "lv";
    LanguageCode["IW"] = "iw";
    LanguageCode["CS"] = "cs";
    LanguageCode["VI"] = "vi";
    LanguageCode["JV"] = "jv";
    LanguageCode["BE"] = "be";
    LanguageCode["KM"] = "km";
    LanguageCode["MK"] = "mk";
    LanguageCode["TR"] = "tr";
    LanguageCode["FY"] = "fy";
    LanguageCode["AM"] = "am";
    LanguageCode["ZH"] = "zh";
    LanguageCode["DA"] = "da";
    LanguageCode["SV"] = "sv";
    LanguageCode["FI"] = "fi";
    LanguageCode["HT"] = "ht";
    LanguageCode["AF"] = "af";
    LanguageCode["LA"] = "la";
    LanguageCode["ID"] = "id";
    LanguageCode["FIL"] = "fil";
    LanguageCode["SM"] = "sm";
    LanguageCode["CA"] = "ca";
    LanguageCode["EL"] = "el";
    LanguageCode["KA"] = "ka";
    LanguageCode["SR"] = "sr";
    LanguageCode["IT"] = "it";
    LanguageCode["SK"] = "sk";
    LanguageCode["RU"] = "ru";
    LanguageCode["RU_LATN"] = "ru-Latn";
    LanguageCode["BG"] = "bg";
    LanguageCode["NY"] = "ny";
    LanguageCode["FA"] = "fa";
    LanguageCode["HAW"] = "haw";
    LanguageCode["GL"] = "gl";
    LanguageCode["ET"] = "et";
    LanguageCode["MS"] = "ms";
    LanguageCode["GD"] = "gd";
    LanguageCode["BG_LATN"] = "bg-Latn";
    LanguageCode["HA"] = "ha";
    LanguageCode["IS"] = "is";
    LanguageCode["UR"] = "ur";
    LanguageCode["MI"] = "mi";
    LanguageCode["HI"] = "hi";
    LanguageCode["BN"] = "bn";
    LanguageCode["HI_LATN"] = "hi-Latn";
    LanguageCode["FR"] = "fr";
    LanguageCode["YI"] = "yi";
    LanguageCode["HU"] = "hu";
    LanguageCode["XH"] = "xh";
    LanguageCode["MY"] = "my";
    LanguageCode["TG"] = "tg";
    LanguageCode["RO"] = "ro";
    LanguageCode["AR"] = "ar";
    LanguageCode["LB"] = "lb";
    LanguageCode["EL_LATN"] = "el-Latn";
    LanguageCode["ST"] = "st";
    LanguageCode["CEB"] = "ceb";
    LanguageCode["KN"] = "kn";
    LanguageCode["AZ"] = "az";
    LanguageCode["SI"] = "si";
    LanguageCode["KY"] = "ky";
    LanguageCode["MG"] = "mg";
    LanguageCode["EN"] = "en";
    LanguageCode["GU"] = "gu";
    LanguageCode["ES"] = "es";
    LanguageCode["PL"] = "pl";
    LanguageCode["JA_LATN"] = "ja-Latn";
    LanguageCode["GA"] = "ga";
    LanguageCode["LT"] = "lt";
    LanguageCode["SN"] = "sn";
    LanguageCode["YO"] = "yo";
    LanguageCode["PA"] = "pa";
    LanguageCode["KU"] = "ku";
    LanguageCode["UNKNOWN"] = "und";
})(LanguageCode || (LanguageCode = {}));
//# sourceMappingURL=languageCode.js.map